import { useOutsideClick } from "@chakra-ui/react"
import React from "react"
import onclickoutside from "react-cool-onclickoutside"

export const useOnclickOutside = (callback: () => void) => {
	const ref = React.useRef<HTMLDivElement>(null)
	onclickoutside(callback, { refs: [ref] })
	return ref
}
